import React from 'react';
import ReactDOM from 'react-dom/client';
// import ComingSoonPage from './App';
import HomePage from './HomePage';
import reportWebVitals from './reportWebVitals';
import { Routes, Route, BrowserRouter } from "react-router-dom";
import Project from './routes/Project'
/* project */
import Description from './routes/Description';
import Contribution from './routes/Contribution';
import Sustainable from './routes/Sustainable';
import Implementation from './routes/Implementation';
/* Wet Lab */
import Engineering from './routes/Engineering';
import Results from './routes/Results';
import Proof from './routes/Proof';


/* Dry Lab */
import Model from './routes/Model';
import Hardware from './routes/Hardware';

/* Human Practices  */
import IHP from './routes/IHP';
import Communication from './routes/Communication';
import Education from './routes/Education';
import Inclusivity from './routes/Inclusivity';
import Sponsor from './routes/Sponsor';

/* Team */
import People from './routes/People';
import Collaborations from './routes/Collaborations';
import Attributions from './routes/Attributions';

import Memes from './routes/Memes';
import './variables.css';
import './Global.css';


const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter basename={process.env.PUBLIC_URL} >
    <Routes >
      {/* <Route path="/" element={<ComingSoonPage />}/> */}
      <Route path="/" element={<HomePage />}>
        <Route path='/' element={<Project/>} /> 
        {/* project */}
        <Route path='/description' element={<Description/>} /> 
        <Route path='/contribution' element={<Contribution/>} /> 
        <Route path='/Sustainable' element={<Sustainable/>} /> 
        <Route path='/implementation' element={<Implementation/>} /> 
        {/* Wet Lab */}
        <Route path='/engineering' element={<Engineering/>} /> 
        <Route path='/results' element={<Results/>} /> 
        <Route path='/proof-of-concept' element={<Proof/>} /> 
        {/* Dry Lab */}
        <Route path='/model' element={<Model/>} />
        <Route path='/hardware' element={<Hardware/>} />

        {/* Human Practices  */}
        <Route path='/human-practices' element={<IHP/>} /> 
        <Route path='/communication' element={<Communication/>} /> 
        <Route path='/education' element={<Education/>} /> 
        <Route path='/Inclusivity' element={<Inclusivity/>} /> 
        <Route path='/Sponsors' element={<Sponsor/>} /> 

        {/* Team */}
        <Route path='/people' element={<People/>} /> 
        <Route path='/collaborations' element={<Collaborations/>} /> 
        <Route path='/attributions' element={<Attributions/>} />
        
        <Route path='/meme-gallery' element={<Memes/>} /> 

      </Route>
      
    </Routes>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
